<template>
  <div class="sena-editions">
    <span id="s-add-up">
      <SenaEditionAddUpdate
        v-if="showAdd"
        @showAdd="close"
        @showMore="showMore"
        :page="page"
        :titleCard="titleCard"
        :updateData="updateData"/>
    </span>
    <span id="s-notify">
      <SenaSendNotification
        v-if="notifyEdition"
        :edition="notifyEdition"
        @close="closeNotify"
      />
    </span>
    <va-card :title="$t('sena.cards.title')">
      <template slot="actions">
        <va-button
          @click="open"
          href='#s-add-up'
          icon="fa fa-plus"
        />
      </template>
      <va-data-table
        :fields="fields"
        :data="editions"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
        <template slot="status" slot-scope="props">
          <va-badge :color="statusColor(props.rowData.status)">
            {{ $t('sena.status.' + props.rowData.status) }}
          </va-badge>
        </template>

        <template slot="progress" slot-scope="props">
          <span v-if="props.rowData.progress">
            {{ props.rowData.progress.games_resolved }}/{{ props.rowData.progress.games_total }}
            <small class="ml-2">
              {{ $t('sena.labels.aliveShort', {
                alive: props.rowData.progress.tickets_alive,
                total: props.rowData.progress.tickets_total,
              }) }}
            </small>
          </span>
          <span v-else>—</span>
        </template>

        <template slot="actions" slot-scope="props">
          <va-popover :message="`${$t('sena.tooltips.games')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-list-alt"
              :to="{ name: 'sena-games', params: { edition: props.rowData.id } }"
            />
          </va-popover>
          <va-popover :message="`${$t('sena.tooltips.tickets')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-ticket"
              :to="{ name: 'sena-tickets', params: { edition: props.rowData.id } }"
            />
          </va-popover>
          <va-popover :message="`${$t('sena.tooltips.ranking')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-signal"
              :to="{ name: 'sena-ranking', params: { edition: props.rowData.id } }"
            />
          </va-popover>
          <va-popover :message="`${$t('sena.tooltips.settlement')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-trophy"
              :to="{ name: 'sena-settlement', params: { edition: props.rowData.id } }"
            />
          </va-popover>
          <va-popover :message="`${$t('sena.tooltips.winners')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-money"
              :to="{ name: 'sena-winners', params: { edition: props.rowData.id } }"
            />
          </va-popover>
          <!--
            Sem botão em DRAFT: a edição ainda não é visível para o assinante
            (o filtro de SELECT do papel `client` só libera OPEN, LOCKED,
            FINISHED e CANCELED), então notificar levaria a uma página vazia.
          -->
          <va-popover
            v-if="props.rowData.status !== 'DRAFT'"
            :message="`${$t('sena.tooltips.notify')}`"
            placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-send-o"
              href="#s-notify"
              @click="notify(props.rowData)"
            />
          </va-popover>
          <va-popover :message="`${$t('sena.tooltips.update')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-pencil"
              href='#s-add-up'
              @click="update(props.rowData)"
            />
          </va-popover>
          <!--
            Excluir só em DRAFT: trg_sena_eg_guard bloqueia o CASCADE em
            sena_edition_game quando a edição saiu de DRAFT. É proposital
            (trilha de auditoria), então o botão nem aparece.
          -->
          <va-popover v-if="props.rowData.status === 'DRAFT'" :message="`${$t('tooltips.delete')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-trash"
              @click="showModal(props.rowData)"
            />
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
    <va-modal
      v-model="modalDeletar"
      size="small"
      :title="$t('modals.titleDelete')"
      :message="$t('sena.modals.deleteEdition')"
      :okText="$t('modals.confirm')"
      :cancelText="$t('modals.cancel')"
      @ok="deleting"
    />
  </div>
</template>

<script>
import gql from 'graphql-tag'
import SenaEditionAddUpdate from './SenaEditionAddUpdate'
import SenaSendNotification from './SenaSendNotification'
import { senaErrorMixin } from './senaErrors'

const perPage = 10

const STATUS_COLORS = {
  DRAFT: 'gray',
  OPEN: 'success',
  LOCKED: 'warning',
  FINISHED: 'info',
  CANCELED: 'danger',
}

export default {
  name: 'sena-editions',
  mixins: [senaErrorMixin],
  components: {
    SenaEditionAddUpdate,
    SenaSendNotification,
  },
  data () {
    return {
      editions: [],
      page: 1,
      perPage: perPage,
      pages: null,
      loading: false,
      showAdd: false,
      modalDeletar: false,
      deleteId: 0,
      titleCard: '',
      updateData: null,
      notifyEdition: null,
    }
  },
  methods: {
    statusColor (status) {
      return STATUS_COLORS[status] || 'gray'
    },
    close (v) {
      this.showAdd = v
      this.updateData = null
    },
    update (data) {
      this.titleCard = 'update'
      this.updateData = data
      this.showAdd = true
    },
    open () {
      this.updateData = null
      this.showAdd = true
      this.titleCard = 'create'
    },
    notify (data) {
      // Remonta o formulário a cada clique: sem isso, trocar de edição com o
      // card aberto manteria os textos preenchidos com os dados da anterior.
      this.notifyEdition = null
      this.$nextTick(() => {
        this.notifyEdition = data
      })
    },
    closeNotify () {
      this.notifyEdition = null
    },
    showModal (data) {
      this.modalDeletar = true
      this.deleteId = data
    },
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.editions.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
    deleting () {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($id: Int!) {
              delete_sena_edition_by_pk(id: $id) {
                id
              }
            }
          `,
          variables: { id: this.deleteId.id },
        })
        .then(() => {
          this.$apollo.queries.pages.refetch()
          this.showMore(this.page)
          this.senaToastSuccess('toasts.successDelete')
        })
        .catch(error => this.senaToastError(error, 'toasts.errorDelete'))
    },
  },
  apollo: {
    editions: {
      query: gql`
      query MyQuery($page: Int = 0, $perPage: Int = 10) {
        editions: sena_edition(limit: $perPage, offset: $page, order_by: {edition_number: desc}) {
          id
          edition_number
          name
          prize_amount
          prize_amount_5
          lockout_at
          status
          total_tickets
          total_winners
          total_winners_5
          settled_at
          sena_edition_is_open
          progress: edition_progress {
            games_total
            games_resolved
            games_blocked
            tickets_total
            tickets_alive
          }
        }
      }
      `,
      variables () {
        return { perPage, page: 0 }
      },
    },
    pages: gql`
    query MyQuery {
      pages: sena_edition_aggregate {
        aggregate {
          count
        }
      }
    }
    `,
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    fields () {
      const moment = this.$moment
      return [
        {
          name: 'edition_number',
          title: this.$t('sena.headings.number'),
          width: '60px',
          dataClass: 'text-center',
        },
        {
          name: 'name',
          title: this.$t('sena.headings.name'),
        },
        {
          name: '__slot:status',
          title: this.$t('sena.headings.status'),
          dataClass: 'text-center',
          titleClass: 'text-center',
          width: '120px',
        },
        {
          name: 'lockout_at',
          title: this.$t('sena.headings.lockout'),
          width: '180px',
          callback (value) {
            return value ? moment(value).format('DD/MM/YYYY [às] HH:mm') : '—'
          },
        },
        {
          name: '__slot:progress',
          title: this.$t('sena.headings.progress'),
          dataClass: 'text-center',
          titleClass: 'text-center',
          width: '150px',
        },
        {
          name: 'prize_amount',
          title: this.$t('sena.headings.prize'),
          width: '170px',
          callback (value) {
            return Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          },
        },
        {
          name: 'prize_amount_5',
          title: `${this.$t('sena.headings.prize')} (${this.$t('sena.labels.prizeTier5')})`,
          width: '170px',
          callback (value) {
            return Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          },
        },
        {
          name: '__slot:actions',
          title: this.$t('tables.actions'),
          dataClass: 'text-center',
          titleClass: 'text-center',
        },
      ]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('editions')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.editions.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
